import React, { useState, useEffect } from 'react';

const MoneyInput = ({
  value = 0,
  onValueChange,
  placeholder = '0.00',   // ✅ placeholder default
  disabled = false,       // ✅ disabled flag
  required = false,       // ✅ required flag
  className = '',
  align = 'right',
  name,
  id,
  min,
}) => {
  const [display, setDisplay] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  const format = (num) => {
    if (!required && (!num || num === 0)) return '';

    const safe = Number(num) || 0;

    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(safe);
  };

  const parse = (str) => {
    if (!str) return 0;

    const cleaned = str
      .replace(/,/g, '')
      .replace(/[^\d.]/g, '');

    const num = parseFloat(cleaned);
    return Number.isFinite(num) ? num : 0;
  };

  // Sync external value ONLY when not editing
  useEffect(() => {
    if (!isEditing) {
      setDisplay(format(value));
    }
  }, [value, isEditing, required]);

  const handleChange = (e) => {
    const raw = e.target.value;
    setDisplay(raw);
    onValueChange?.(parse(raw));
  };

  const handleFocus = () => {
    if (disabled) return;
    setIsEditing(true);
    setDisplay((prev) => String(prev || '').replace(/,/g, ''));
  };

  const handleBlur = () => {
    setIsEditing(false);

    let numeric = parse(display);

    if (typeof min === 'number' && numeric < min) {
      numeric = min;
    }

    setDisplay(format(numeric));
    onValueChange?.(numeric);
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      value={display}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={placeholder}   // ✅ now fully supported
      disabled={disabled}         // ✅ disabled works
      required={required}
      name={name}
      id={id}
      className={`
        border rounded px-2 py-1 text-sm tabular-nums
        focus:outline-none focus:ring-1 focus:ring-primary-500
        ${align === 'right' ? 'text-right' : 'text-left'}
        ${disabled ? 'bg-ink-canvas text-ink-body cursor-not-allowed' : ''}
        ${className.includes('w-') ? '' : 'w-28'}
        ${className}
      `}
    />
  );
};

export default MoneyInput;